import { ValidationResult } from './validation-result.model';

export function validateDeadlineString(
  deadline: string | null,
  createdAtIsoString?: string | null,
): ValidationResult {
  const errors: string[] = [];
  if (!deadline) {
    return { isValid: true, errors: [] };
  }

  if (!/^\d{4}-\d{2}-\d{2}$/.test(deadline)) {
      errors.push('Deadline must be a valid YYYY-MM-DD string.');
      return { isValid: false, errors };
  }

  const [year, month, day] = deadline.split('-').map(Number);
  const deadlineDateObj = new Date(year, month - 1, day);
  if (deadlineDateObj.getFullYear() !== year || deadlineDateObj.getMonth() !== month - 1 || deadlineDateObj.getDate() !== day) {
      errors.push('Deadline is not a real calendar date.');
      return { isValid: false, errors };
  }

  if (!createdAtIsoString) {
    return { isValid: errors.length === 0, errors };
  }

  const createdDateObj = new Date(createdAtIsoString);
  if (isNaN(createdDateObj.getTime())) {
    errors.push('Card creation date is invalid or corrupted.');
    return { isValid: false, errors };
  }

  const localYear = createdDateObj.getFullYear();
  const localMonth = String(createdDateObj.getMonth() + 1).padStart(2, '0');
  const localDay = String(createdDateObj.getDate()).padStart(2, '0');
  const createdDateLocalString = `${localYear}-${localMonth}-${localDay}`;

  if (deadline < createdDateLocalString) {
      errors.push('Deadline cannot be earlier than the creation date.');
  }

  return { isValid: errors.length === 0, errors };
}
